import React, {useEffect, useState} from 'react'
import Color from '../../Components/Colors/Color'
import ClipLoader from 'react-spinners/ClipLoader'
import CustomSnackbar from '../Components/Snackbar/Snackbar'
import '../Styles/AdminProfilePage.css'
import '../Components/Overlay/Overlay.css'
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import { editProfile, fetchUserDetail } from '../Controller/ProfileController'

const AdminProfilePage = () => {

    const navigate = useNavigate();


    const [user, setUser] = useState({});
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');

    const [loading, setLoading] = useState(false);
    const [loadingOverlay, setLoadingOverlay] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [failure, setFailure] = useState(false);
    const [finishFlag, setFinishFlag] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);
    const [emptyTokenFlag, setEmptyTokenFlag] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);

    const handleCloseOverlay = () => {
        setShowOverlay(false);
    }

    const handleOpenOverlay = () => {
        setShowOverlay(true);
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent the default Enter key action
          handleEditProfile(e); // Trigger the Update action
          e.target.blur();
        }
    };

    const tokenChecker = () => {
        let token = localStorage.getItem('authToken');
        if (!token) {
            setSeveritySnackbar("error");
            setMessageSnackbar("Token not found, please log in again!");
            setSnackbarDuration(3000);
            setOpenSnackbar(true);
            localStorage.removeItem('authToken');
            navigate("/admin");
            return null;
        }

        let decodedToken = jwtDecode(token);

        if (decodedToken && decodedToken.exp * 1000 > Date.now()){
            return decodedToken.sub;
        } else {
            setSeveritySnackbar("error");
            setMessageSnackbar("Token has expired, please log in again!");
            setSnackbarDuration(3000);
            setOpenSnackbar(true);
            localStorage.removeItem('authToken');
            navigate("/admin");
            return null;
        }
    }

    useEffect(() => {
        if(!openSnackbar && emptyTokenFlag){
            setEmptyTokenFlag(false);
            localStorage.removeItem('authToken');
            navigate("/admin");
            return
        }
    }, [openSnackbar && emptyTokenFlag])


    const handleFetchProfile = async () => {
        let userId = tokenChecker();

        try{
            setLoading(true);
            const response = await fetchUserDetail(userId);
            const status = response.status;

            if(status === 200){
                const userFound = response.data.user;
                setUser(userFound || {});
                if(userFound){
                    setFirstName(userFound?.firstName);
                    setLastName(userFound?.lastName);
                    setEmail(userFound?.email);
                }
            } else {
                console.log("response" + response);
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occurred");
                setSnackbarDuration(3000);
                setOpenSnackbar(true);                  
            }

        }catch(error)  {
            if(error?.response?.status === 404){
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "No Profile found");
                setSnackbarDuration(3000);
                setFailure(true);
                setOpenSnackbar(true); 
            } else{
                setMessageSnackbar(error?.response?.data?.message || "An error occurred")
                setSeveritySnackbar("error");
                setOpenSnackbar(true);
            }
        }finally{
            setLoading(false);
        }
    }


    useEffect(() => {
        

        handleFetchProfile();

    }, [])

    useEffect(() => {
        if(!openSnackbar && success){
            setSuccess(false);
        }

        if(!openSnackbar && failure){
            setFailure(false);
            navigate('/admin-dashboard');
        }

        if(!openSnackbar && finishFlag){
            setFinishFlag(false);
        }
    }, [success && openSnackbar, failure && openSnackbar, finishFlag && openSnackbar]) 

    useEffect(() => {
        window.scrollTo(0,0);
    },[])

    


    const handleEditProfile = async (e) => {
        e.preventDefault();

        if(!firstName || !email) return;

        let userId = tokenChecker();

        const userFinal = {
            "firstName": firstName,
            "lastName": lastName || '',
            "email": email
        }

        try{
            setLoadingOverlay(true);

            const response = await editProfile(userId, userFinal);
         
            if(response.status === 200){
                setSeveritySnackbar('success')
                setMessageSnackbar(response?.data?.message);
                setSnackbarDuration(3000);
                setSuccess(true);
                setShowOverlay(false);
                setOpenSnackbar(true);

                handleFetchProfile();
            } else {
                console.log("response" + response);
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occurred");
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
            }
            
        }   catch (error) {
            if(error?.response?.status === 404){
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "No Profile found");
                setSnackbarDuration(3000);
                setSuccess(true);
                setOpenSnackbar(true); 
            } else{
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                setSnackbarDuration(3000);
                setFinishFlag(true);
                setOpenSnackbar(true);
            }
        } finally{
            setLoadingOverlay(false);
        }
    }

    const handleMoveToChangePassword = () => {
        navigate('./change-password');
    }

    const handleStopPropagation = (e) => {
        e.stopPropagation();
    }
    
    return(
        <>
        <div className={`profile-page`}>
            <div className={`profile-page-container card`}>
                <div className="profile-name-btn-container">
                    <div className="profile-header">
                        <h5>Profile</h5>
                    </div>
                    <div className="profile-btn-container">
                        <button className={`profile-edit-btn`} onClick={handleOpenOverlay}>
                            <span className="fa-solid fa-pencil"></span>
                            Edit
                        </button>
                        <button className={`profile-change-password-btn`} onClick={handleMoveToChangePassword}>
                            Change Password
                        </button>
                    </div>
                </div>

                <div className="profile-hl-container">
                        <hr className="profile-hl" />
                </div>

                <div className={`loading-container ${loading ? "" : "stop"}`}>
                        <ClipLoader color='black' size={100} />
                </div>

                
                {!loading && ( // add firstName for condition
                    <div className="profile-detail-container row">
                        <div className={`profile-detail-parameter-value col-lg-6 col-md-6`}>
                            <p className={`profile-detail-parameter`}>
                                Name:
                            </p>
                            <p className={`profile-detail-value`}>
                                {user?.firstName ? user?.firstName.charAt(0).toUpperCase() + user?.firstName.slice(1) : "" || "None"} {user?.lastName ? user?.lastName.charAt(0).toUpperCase() + user?.lastName.slice(1) : "" || ""}
                            </p>
                        </div>
                        {/* <div className={`profile-detail-parameter-value col-lg-6 col-md-6`}>
                            <p className={`profile-detail-parameter`}>
                                Phone Number:
                            </p>
                            <p className={`profile-detail-value`}>
                                {user?.phoneNumber || "No Phone Number"}
                            </p>
                        </div> */}
                        <div className={`profile-detail-parameter-value col-lg-6 col-md-6`}>
                            <p className={`profile-detail-parameter`}>
                                Email:
                            </p>
                            <p className={`profile-detail-value`}>
                                {user?.email || "None"}
                            </p>
                        </div>
                        {/* <div className="toggle-btn col-lg-6 col-md-6">
                            <h6>Theme: </h6>
                            <label htmlFor="toogle-btn" className="switch-theme">
                                <input 
                                    type="checkbox" 
                                    id="toogle-btn" 
                                    checked={theme} 
                                    onChange={handleThemeChange} 
                                    />
                                    
                                <span className="slider round round-theme"></span>
                            </label>
                        </div> */}
                    </div>        
                )}
                        
            </div>
        </div>
        {showOverlay && (
            <div className="overlay-container" onClick={() => setShowOverlay(false)}>
                <div className={`overlay-content`} style={{color: Color.thirdText}} onClick={handleStopPropagation}>
                    <h5>Edit Profile</h5>
                    <div className="edit-profile-form-container">
                        <form className="edit-profile-form" onSubmit={handleEditProfile}>
                            <div className="edit-profile-label-input">
                                <label htmlFor="first-name" className={`edit-profile-label`}>
                                    First Name
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter First Name"
                                    className={`edit-profile-input`}
                                    id="first-name"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                    required
                                    />
                            </div>
                            <div className="edit-profile-label-input">
                                <label htmlFor="last-name" className={`edit-profile-label`}>
                                    Last Name
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter Last Name"
                                    className={`edit-profile-input`}
                                    id="last-name"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                    />
                            </div>
                            <div className="edit-profile-label-input">
                                <label htmlFor="email" className={`edit-profile-label`}>
                                    Email
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter Email"
                                    className={`edit-profile-input`}
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                    required
                                    />
                            </div>

                            <div className="edit-profile-btn-container">
                                <button className={`edit-profile-discard-btn`} onClick={handleCloseOverlay}>
                                    Discard
                                </button>
                                <button className="edit-profile-update-btn" type="submit">
                                    Update
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className={`loading-container-overlay ${loadingOverlay ? "" : "stop"}`}>
                            <ClipLoader color='white' size={100} />
                    </div>
                </div>
            </div>
        )}
        <CustomSnackbar
            severity={severitySnackbar}
            message={messageSnackbar}
            open={openSnackbar}
            onClose={() => setOpenSnackbar(false)}
            time= {snackbarDuration}
        />
    </>
    )
}

export default AdminProfilePage;